import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";
import logo from "../AROCL.png";

const Navbar = () => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    setOpenDropdown(false);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setOpenDropdown(false);
  };

  const toggleDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  return (
    <nav className="navbar">
      <img src={logo} alt="Company Logo" className="logo" />
      
      <button 
        className="navbar-toggle" 
        onClick={toggleMobileMenu}
        aria-label="Toggle menu"
      >
        ☰
      </button>
      <ul className={`nav-links ${mobileMenuOpen ? "active" : ""}`}>
        <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
        
        {/* Services Dropdown */}
        <li 
          className="dropdown"
          onMouseEnter={() => setOpenDropdown(true)}
          onMouseLeave={() => setOpenDropdown(false)}
        >
          <span 
            className="dropdown-title"
            onClick={toggleDropdown}
            role="button"
            tabIndex="0"
          >
            Services ▾
          </span>
          {openDropdown && (
            <ul className="dropdown-menu active">
              <li><Link to="/warehousing" onClick={closeMobileMenu}>Warehousing</Link></li>
              <li><Link to="/aircargo" onClick={closeMobileMenu}>Air Cargo</Link></li>
              <li><Link to="/seacargo" onClick={closeMobileMenu}>Sea Cargo</Link></li>
              <li><Link to="/insurance" onClick={closeMobileMenu}>Insurance</Link></li>
              <li><Link to="/customs" onClick={closeMobileMenu}>Customs Clearance</Link></li>
              <li><Link to="/logistics" onClick={closeMobileMenu}>Logistics</Link></li>
            </ul>
          )}
        </li>

        <li><Link to="/#about" onClick={closeMobileMenu}>About</Link></li>
        <li><Link to="/#contact" onClick={closeMobileMenu}>Contact</Link></li>
      </ul>
    </nav>
  );
};

export default Navbar;
